import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-11-02 14:09:36 +0100 (Sun, 02 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 157721 $
//  Purpose   : fulltext parts
// =============================================================================
import React from 'react';
import { loadLazy as ll, funcPart } from 'uix/parts';
export const EngineReports = ll(()=>import(/* webpackChunkName: 'fulltext' */ './engines'));
export const PassageViewer = ll(()=>import(/* webpackChunkName: 'fulltext' */ './passages'));
export const OcrDashboard = ll(()=>import(/* webpackChunkName: 'fulltext' */ './dashboard'));
export const TextlabConfig = ll(()=>import(/* webpackChunkName: 'fulltext' */ './config'));
export const LayoutControl = ll(()=>import(/* webpackChunkName: 'fulltext' */ './LayoutControl'));
const _OcrInfoList = ll(()=>import(/* webpackChunkName: 'fulltext' */ './list'));
export const OcrInfoList = funcPart({
    getGraphics: [
        'types'
    ]
}, (props)=>/*#__PURE__*/ _jsx(_OcrInfoList, {
        ...props
    }));
export const FulltextEditor = ll(()=>import(/* webpackChunkName: 'fulltext' */ '../editor/part'));
export const NamedEntities = ll(()=>import(/* webpackChunkName: 'fulltext' */ './entities'));
export const CompareEngineTests = ll(()=>import(/* webpackChunkName: 'fulltext' */ './compare'));
